// extracted by mini-css-extract-plugin
export var deliveryRow = "_rg-a";
export var fixedHeight = "_rg-4";
export var freightLogo = "_rg-9";
export var fullWidth = "_rg-3";
export var priceColumn = "_rg-5";
export var radioSelected = "_rg-7";
export var radioUnselected = "_rg-6";
export var selectedOption = "_rg-2";
export var selectedOptionContainer = "_rg-1";
export var selection = "_rg-0";
export var tallSkeletonText = "_rg-8";